import { render, staticRenderFns } from "./GridRows.vue?vue&type=template&id=2af4de96&"
import script from "./GridRows.vue?vue&type=script&lang=js&"
export * from "./GridRows.vue?vue&type=script&lang=js&"
import style0 from "./GridRows.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports